import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-generic-tip',
  templateUrl: './generic-tip.component.html',
  styleUrls: ['./generic-tip.component.scss']
})
export class GenericTipComponent {
  @Output() close: EventEmitter<any> = new EventEmitter();
  @Input() tipText: string;
  constructor() {}

  closeModal(): void {
    this.close.emit(true);
  }
}
